import { completed } from './helpers';
import { OPEN_MODAL } from './constants';

export function openReactModal(content, onForceClose = null) {
  return (dispatch) => {
    dispatch(completed(OPEN_MODAL, { content, onForceClose }));
  };
}

export function closeReactModal() {
  return openReactModal(null);
}
